module.exports = __webpack_public_path__ + "static/media/reports_payment.6d405f32.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_payment.md
// module id = 1113
// module chunks = 0